import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const InviteOverview = lazy(() => import('./invite-overview'));
const InviteCreate = lazy(() => import('./invite-create/invite-create.component'));
const InviteDetail = lazy(() => import('./invite-detail/invite-detail.component'));
const InviteUpdate = lazy(() => import('./invite-update/invite-update.component'));

export function InviteRoutes() {
    return (
        <Route path='invites'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <InviteOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <InviteCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':inviteId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <InviteDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <InviteUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    index
                    element={<Navigate to='../' />}
                />
            </Route>
        </Route>
    );
}
